import {combineReducers} from 'redux'
import {createPaginatedAction, createSelectAction, payloadReducer} from '../../../utils/redux-utils'
import {createReducer, isActionOf} from 'typesafe-actions'
import {combineEpics} from 'redux-observable'
import type {RootEpic} from '../../root'
import {concatMap, filter, map, startWith, switchMap, takeUntil} from 'rxjs/operators'
import {apiRequests} from '../../../http/config'
import {paginate} from '../../../utils/rx-operators'
import {toastFailedResponse} from '../../../components/controls/Toaster/Toaster'
import {ContactsUser} from '../../../responses/users'
import {pipe} from 'fp-ts/es6/pipeable'
import {idToggle} from '../../../utils/entity-utils'
import {ID} from '../../../types/UtilityTypes'

const LIMIT = 30

const actions = {
    list: createPaginatedAction(
        '@CONTACTS_USERS/LIST_INIT',
        '@CONTACTS_USERS/LIST_MORE',
        '@CONTACTS_USERS/LIST_SUCCESS',
        '@CONTACTS_USERS/LIST_FAILURE',
    )<string, ContactsUser[]>(),
    openContacts: createSelectAction(
        '@CONTACTS_USERS/OPEN_CONTACTS_SET',
        '@CONTACTS_USERS/OPEN_CONTACTS_TOGGLE',
        '@CONTACTS_USERS/OPEN_CONTACTS_TOGGLE_ALL',
    ),
}

export {actions as contactsActions}

export interface ContactsState {
    search: string,
    data: ContactsUser[],
    openContacts: ID[]
}

export const contactsReducer = combineReducers<ContactsState>({
    search: createReducer('')
        .handleAction(actions.list.init, (_, action) => action.payload),
    data: createReducer<ContactsUser[]>([])
        .handleAction(actions.list.init, () => [])
        .handleAction(actions.list.success, (state, action) => state.concat(action.payload)),
    openContacts: createReducer<ID[]>([])
        .handleAction(actions.openContacts.set, payloadReducer)
        .handleAction(actions.openContacts.toggle, (state, {payload}) => pipe(state, idToggle(payload))),
})

const list: RootEpic = action$ => action$.pipe(
    filter(isActionOf(actions.list.init)),
    switchMap(action => action$.pipe(
        startWith(actions.list.more()),
        takeUntil(filter(isActionOf(actions.list.init))(action$)),
        filter(isActionOf(actions.list.more)),
        paginate(LIMIT),
        concatMap(offset => apiRequests.users.contacts({
            query: {
                offset,
                limit: LIMIT,
                search: action.payload,
                all: 1,
            }
        })),
        map(res => res.response.success ?
            actions.list.success(res.response.rows) :
            actions.list.failure(toastFailedResponse(res.response, 'Не удалось получить список пользователей'))
        ),
    )),
)

export const contactsEpic = combineEpics(list)
